import React from 'react'

import * as styles from './ContainerSlim.module.css';

export default function ContainerSlim({ children }) {
  return (
    <div className={`${styles.containerSlim} mx-auto max-w-3xl p-6 lg:px-8`}>
      {children}
    </div>
  );
}
